export default "__VITE_ASSET__85e00a08__"